import { render, staticRenderFns } from "./CollectionNewDialog.vue?vue&type=template&id=ad14bc34&scoped=true&lang=true"
import script from "./CollectionNewDialog.vue?vue&type=script&lang=js"
export * from "./CollectionNewDialog.vue?vue&type=script&lang=js"
import style0 from "./CollectionNewDialog.vue?vue&type=style&index=0&id=ad14bc34&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad14bc34",
  null
  
)

export default component.exports